<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("Sales Register Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                  :disabled-dates="disabledDates"
                >
                </Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">✖</button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                  :disabledDates="{
                    from: new Date(
                      moment(fromDate)
                        .add(45, 'd')
                        .format('YYYY-MM-DD')
                    ),
                  }"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <!-- :disabledDates="{
                    from: new Date(
                      moment(fromDate)
                        .add(31, 'd')
                        .format('YYYY-MM-DD')
                    )
                  }" -->

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getSalesRegisterReport()"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div class="col-lg-6 col-xl-2 p-0" v-if="salesRegisterRecords.length">
            <div
              class="align-self-center mb-3 d-flex justify-content-end align-items-center"
            >
              <div class="mx-1">{{ $t("download") }} as:</div>
              <!-- s -->

              <span
                @click="excelDownload(BASE_URL)"
                title="Download as Excel"
                style="cursor: pointer"
              >
                <img
                  class="mx-1"
                  src="@/assets/img/icons/excel.svg"
                  height="25"
                  width="25"
                />
              </span>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <div
            class="d-flex align-item-center justify-content-center"
            style="gap: 15px"
          >
            <b-form-input
              v-debounce:500="onSearch"
              v-model="searchValue"
              placeholder="Search..."
            />
          </div>
          <div class="d-flex"></div>
          <div class="align-items-center">
            <div class="mx-2 text-left d-flex justify-content-end">
              <b-dropdown name="listview" id="listview" variant="outline-blue">
                <template v-slot:button-content>
                  {{ $t("viewing") }}&nbsp;
                  <strong>{{ selectedvalue }}</strong>
                  &nbsp;{{ $t("of") }}&nbsp;
                  <strong>{{ rows }}</strong>
                </template>
                <b-dropdown-item
                  v-for="(list, listIndex) in viewingnumbers"
                  :key="listIndex"
                  @click="onDropDownChangeValue(list.name)"
                  href="#"
                  >{{ list.name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>
        </div>
      </div>

      <div
        style="overflow-x: scroll !important; width: auto !important"
        v-if="salesRegisterRecords.length > 0"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <tr class="bg-lightgrey font-weight-bold">
            <th>Unit Name</th>
            <th>Business Date</th>
            <th>Transaction Id</th>
            <th>Receipt No</th>
            <!-- <th>Digital OrderId</th> -->
            <th>DB Date</th>
            <th>DB Time</th>
            <th>Invoice No.</th>
            <th>OutLet</th>
            <th>Category/Genre</th>
            <th>Movie/Item</th>
            <th>Calendar ShowDate</th>
            <th>ShowDate</th>
            <th>ShowTime</th>
            <th>POS ID</th>
            <th>Employee Code</th>
            <th>User Name</th>
            <th>Screen Name</th>
            <th>Seat Name</th>
            <th>Partner ID</th>
            <!-- <th>Sell Type</th> -->
            <th>Terminal ID</th>
            <th>Merchant Track ID</th>
            <th>Refernce ID</th>
            <!-- <th>STAN</th>
            <th>TVR</th> -->
            <th>Card No.</th>
            <th>Qty</th>
            <th>Unit Price</th>
            <th>Amount Exclude VAT & GCAM</th>
            <th>Base Amount</th>
            <!-- <template v-for="(chargesData, chargesIndex) in chargesArr"> -->
            <th>VAT</th>
            <th>GCAM</th>
            <!-- </template> -->
            <th>Total Amount</th>
            <th>Payment Method</th>
            <th>Amount</th>
            <th>Ewallet</th>
            <th>Booking Fees</th>
            <th>VAT ON Booking Fees</th>
            <th>Total Booking Fees</th>
            <th>Total Invoice Amount</th>
            <th>AddOns</th>
            <th>Voucher/Offer Name</th>
            <th>Voucher/Offer Code</th>
            <th>Discount</th>
            <th>Refund Type</th>
            <th>Refunded By</th>
            <th>Refund Reason</th>
            <template v-if="addonsTotalArr.length">
              <template v-for="item in addonsTotalArr">
                <th v-for="(item1, index) in 3" :key="index + item.marc_id">
                  {{
                    index == 0
                      ? `${item.addons_name} Charge`
                      : index == 1
                      ? ` VAT on ${item.addons_name} Charge`
                      : ` Total ${item.addons_name} Charge`
                  }}
                </th>
              </template>
            </template>
            <th>Swap With Invoice No</th>
            <th>Swap With Transaction ID</th>
            <th>Print</th>
          </tr>
          <tbody>
            <template
              v-for="(salesRegisterData,
              salesRegisterIndex) in salesRegisterRecords"
            >
              <tr
                v-if="!salesRegisterData.hasOwnProperty('fst_id')"
                :key="'Sales' + salesRegisterIndex"
              >
                <td class="text-left">{{ salesRegisterData.unit_name }}</td>
                <td class="text-left">
                  {{
                    moment(salesRegisterData.business_date).format("YYYY-MM-DD")
                  }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.invoice_no }}
                </td>
                <td class="text-left">
                  {{
                    salesRegisterData.invoice_no
                      ? salesRegisterData.invoice_no.split("", 1)[0]
                      : "-"
                  }}{{ salesRegisterData.sb_id
                  }}{{ salesRegisterData.invoice_no }}
                </td>
                <!-- <td class="text-left">Digital OrderId</td> -->
                <td class="text-left">
                  {{
                    moment(salesRegisterData.transaction_date).format(
                      "YYYY-MM-DD"
                    )
                  }}
                </td>
                <td class="text-left">
                  {{
                    moment(salesRegisterData.transaction_date).format("HH:mm")
                  }}
                </td>
                <td
                  class="text-left"
                  :style="
                    salesRegisterData.refund_payment_method ? 'color:red' : ''
                  "
                >
                  {{ salesRegisterData.refund_payment_method ? "R" : "" }}T{{
                    salesRegisterData.sb_id
                  }}
                </td>
                <td class="text-left">{{ salesRegisterData.outlet }}</td>
                <td class="text-left">
                  {{ `${salesRegisterData.genre_name || "-"}` }}
                </td>
                <td class="text-left">
                  {{ `${salesRegisterData.movie_name || "-"}` }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.calendar_show_date || "-" }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.show_date || "-" }}
                </td>
                <td class="text-left">{{ salesRegisterData.show_time }}</td>
                <td class="text-left">
                  {{ salesRegisterData.pos_id || "-" }}
                </td>
                <td class="text-left">
                  {{
                    salesRegisterData.user_id
                      ? salesRegisterData.user_id
                      : "" || "-"
                  }}
                </td>
                <td class="text-left">{{ salesRegisterData.user_name }}</td>
                <td class="text-left">{{ salesRegisterData.screen_name }}</td>
                <td class="text-left">
                  {{
                    salesRegisterData.seat_name
                      ? salesRegisterData.seat_name.split(",").join(", ")
                      : "-"
                  }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.partner_name || "-" }}
                </td>

                <td class="text-left">
                  <div v-if="salesRegisterData.terminal_id">
                    {{ salesRegisterData.terminal_id || "-" }}
                  </div>
                  <div v-else>-</div>
                </td>

                <td class="text-right">
                  <div v-if="salesRegisterData.merch_track_id">
                    {{ salesRegisterData.merch_track_id || "-" }}
                  </div>

                  <div v-else>-</div>
                </td>

                <td class="text-right">
                  <div v-if="salesRegisterData.ref_id">
                    {{ salesRegisterData.ref_id || "-" }}
                  </div>

                  <div v-else>-</div>
                </td>

                <td class="text-right">
                  <div v-if="salesRegisterData.card_no">
                    {{ salesRegisterData.card_no || "-" }}
                  </div>
                  <div v-else>-</div>
                </td>
                <td class="text-right">
                  {{ salesRegisterData.refund_payment_method ? "-" : ""
                  }}{{
                    salesRegisterData.seat_name
                      ? salesRegisterData.seat_name.split(",").length
                      : "-"
                  }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_payment_method &&
                    salesRegisterData["unit_price"] > 0
                      ? "-"
                      : ""
                  }}{{ currFormat3(salesRegisterData.unit_price) || "0.00" }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_payment_method &&
                    salesRegisterData["amount_before_tax"] > 0
                      ? "-"
                      : ""
                  }}{{
                    currFormat3(salesRegisterData.amount_before_tax) || "0.00"
                  }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_payment_method &&
                    salesRegisterData["amount_before_tax"] > 0
                      ? "-"
                      : ""
                  }}{{
                    currFormat3(
                      salesRegisterData.amount_before_tax +
                        salesRegisterData.gcam_amount
                    ) || "0.00"
                  }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_payment_method &&
                    salesRegisterData["VAT"] > 0
                      ? "-"
                      : ""
                  }}{{ currFormat3(salesRegisterData["VAT"]) || "0.00" }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_payment_method &&
                    salesRegisterData["GCAM"] > 0
                      ? "-"
                      : ""
                  }}{{ currFormat3(salesRegisterData["GCAM"]) || "0.00" }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_payment_method &&
                    salesRegisterData.unit_price > 0
                      ? "-"
                      : ""
                  }}{{ currFormat3(salesRegisterData.unit_price) || "0.00" }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.payment_method }}
                </td>
                <td class="text-left">
                  {{
                    salesRegisterData.refund_payment_method &&
                    salesRegisterData.payment_mode_amount > 0
                      ? "-"
                      : ""
                  }}{{
                    currFormat3(salesRegisterData.payment_mode_amount) || "0.00"
                  }}
                </td>
                <td class="text-left">
                  {{
                    salesRegisterData.refund_payment_method &&
                    salesRegisterData.wallet_amount > 0
                      ? "-"
                      : ""
                  }}{{ currFormat3(salesRegisterData.wallet_amount) || "0.00" }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_payment_method &&
                    salesRegisterData.net_booking_fees > 0
                      ? "-"
                      : ""
                  }}{{
                    currFormat3(salesRegisterData.net_booking_fees) || "0.00"
                  }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_payment_method &&
                    salesRegisterData.net_booking_fees > 0
                      ? "-"
                      : ""
                  }}{{
                    currFormat3(salesRegisterData.net_booking_fees * 0.15) ||
                      "0.00"
                  }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_payment_method &&
                    salesRegisterData.booking_fee > 0
                      ? "-"
                      : ""
                  }}{{ currFormat3(salesRegisterData.booking_fee) || "0.00" }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_payment_method &&
                    salesRegisterData.unit_price > 0
                      ? "-"
                      : ""
                  }}{{
                    currFormat3(
                      parseFloat(
                        parseFloat(salesRegisterData.unit_price) +
                          parseFloat(salesRegisterData.booking_fee)
                      )
                    ) ||
                      (salesRegisterData.unit_price
                        ? currFormat3(salesRegisterData.unit_price)
                        : "0.0")
                  }}
                </td>
                <td class="text-right">
                  <div
                    v-if="
                      salesRegisterData.addonsTotal &&
                        salesRegisterData.addonsTotal.length > 0
                    "
                  >
                    <div
                      v-for="(addOnsData,
                      addOnsIndex) in salesRegisterData.addonsTotal"
                      :key="'addOns-' + addOnsIndex"
                      class="d-flex justify-content-between"
                    >
                      <div>
                        <span class="px-1 text-left">{{
                          addOnsData.quantity || "-"
                        }}</span>
                        <span class="px-1 text-left" v-if="addOnsData.quantity"
                          >x
                          {{
                            currFormat3(addOnsData.single_price) || "0.00"
                          }}</span
                        >
                      </div>
                      <div>
                        <span class="px-1 text-right" v-if="addOnsData.quantity"
                          >- {{ addOnsData.addons_name || "-" }}</span
                        >
                      </div>
                    </div>
                  </div>
                </td>
                <td class="text-left">
                  {{ salesRegisterData.voucher_offer_name }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.voucher_offer_code }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_payment_method &&
                    salesRegisterData.discount
                      ? "-"
                      : ""
                  }}{{ currFormat3(salesRegisterData.discount) || "0.0" }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.refund_payment_method || "-" }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.redunded_user || "-" }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.refund_reason || "-" }}
                </td>

                <template v-if="addonsTotalArr.length">
                  <template v-for="item2 in addonsTotalArr">
                    <td
                      class="text-right"
                      v-for="(item1, index2) in 3"
                      :key="index2 + item2.marc_id"
                    >
                      <template
                        v-if="
                          salesRegisterData.hasOwnProperty('addonsTotal') &&
                            salesRegisterData.addonsTotal &&
                            salesRegisterData.addonsTotal.filter(
                              (z) => z.marc_id == item2.marc_id
                            ).length
                        "
                      >
                        {{
                          salesRegisterData.refund_payment_method &&
                          getDataAddons(
                            salesRegisterData.addonsTotal,
                            index2,
                            item2.marc_id
                          ) > 0
                            ? "-"
                            : ""
                        }}{{
                          currFormat3(
                            getDataAddons(
                              salesRegisterData.addonsTotal,
                              index2,
                              item2.marc_id
                            )
                          )
                        }}
                      </template>
                      <template v-else>-</template>
                    </td>
                  </template>
                </template>
                <td class="text-left">
                  {{
                    salesRegisterData.swap_invoice_no
                      ? `T${salesRegisterData.swap_invoice_no}`
                      : "-"
                  }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.swap_transaction_id || "-" }}
                </td>
                <td class="text-left">
                  <button
                    class="btn-transparent text-blue"
                    @click="printPdf(salesRegisterData)"
                  >
                    <u>View Invoice</u>
                  </button>
                </td>
              </tr>

              <tr
                v-if="salesRegisterData.hasOwnProperty('fst_id')"
                :key="salesRegisterIndex + 'fnbDataIndex'"
              >
                <td class="text-left">{{ salesRegisterData.unit_name }}</td>
                <td class="text-left">
                  {{ salesRegisterData.payment_date || "-" }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.invoice_no || "-" }}
                </td>
                <td class="text-right">
                  {{ salesRegisterData.order_code }}
                </td>
                <td class="text-left">
                  {{
                    moment(salesRegisterData.created_at).format("YYYY-MM-DD") ||
                      "-"
                  }}
                </td>
                <td class="text-left">
                  {{
                    moment(salesRegisterData.created_at).format("HH:mm") || "-"
                  }}
                </td>
                <td
                  class="text-left"
                  :style="salesRegisterData.refund_mode ? 'color:red' : ''"
                >
                  {{ salesRegisterData.refund_mode ? "R" : "" }}F{{
                    salesRegisterData.ft_id
                  }}
                </td>
                <td class="text-left">{{ salesRegisterData.outlet || "-" }}</td>
                <td class="text-left">
                  <template
                    v-for="item in salesRegisterData.fc_category
                      ? salesRegisterData.fc_category.split(', ')
                      : []"
                  >
                    <span :key="'d' + item">
                      {{ item }}
                      {{
                        salesRegisterData.fc_category.split(", ").length - 1 ==
                        salesRegisterData.fc_category.split(", ").indexOf(item)
                          ? ""
                          : ", "
                      }}
                    </span>
                    <br
                      v-if="
                        salesRegisterData.fc_category
                          .split(', ')
                          .indexOf(item) > 0 &&
                          salesRegisterData.fc_category
                            .split(', ')
                            .indexOf(item) %
                            2 ==
                            0
                      "
                      :key="'ds' + item"
                    />
                  </template>
                </td>
                <td class="text-left">
                  <template
                    v-for="item in salesRegisterData.fst_item_name
                      ? salesRegisterData.fst_item_name.split(', ')
                      : []"
                  >
                    <span :key="'d' + item">
                      {{ item }}
                      {{
                        salesRegisterData.fst_item_name.split(", ").length -
                          1 ==
                        salesRegisterData.fst_item_name
                          .split(", ")
                          .indexOf(item)
                          ? ""
                          : ", "
                      }}
                    </span>
                    <br
                      v-if="
                        salesRegisterData.fst_item_name
                          .split(', ')
                          .indexOf(item) > 0 &&
                          salesRegisterData.fst_item_name
                            .split(', ')
                            .indexOf(item) %
                            2 ==
                            0
                      "
                      :key="'ds' + item"
                    />
                  </template>
                </td>
                <!-- <td class="text-left">
                  {{ "-" }}
                </td> -->

                <td class="text-left">
                  {{ salesRegisterData.calendar_show_date || "-" }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.show_date || "-" }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.show_time || "-" }}
                </td>
                <td class="text-left">
                  {{
                    salesRegisterData.hardware_info
                      ? salesRegisterData.hardware_info
                      : "-"
                  }}
                </td>
                <td class="text-left">
                  {{
                    salesRegisterData.up_employee_code
                      ? salesRegisterData.up_employee_code
                      : "-"
                  }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.first_name }}
                  {{ salesRegisterData.last_name }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.screen_name || "-" }}
                </td>
                <td class="text-left">
                  {{ "-" }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.partner_name || "-" }}
                </td>
                <!-- <td class="text-left">
                  {{
                    salesRegisterData.Combo_item_name
                      ? `Combo - ${salesRegisterData.Combo_item_name}`
                      : salesRegisterData.combo_data
                      ? "Combo"
                      : "Single"
                  }}
                </td> -->
                <td class="text-left">
                  <div v-if="salesRegisterData.terminal_id">
                    {{ salesRegisterData.terminal_id || "-" }}
                  </div>

                  <div v-else>-</div>
                </td>

                <td class="text-right">
                  <div v-if="salesRegisterData.merch_track_id">
                    {{ salesRegisterData.merch_track_id || "-" }}
                  </div>

                  <div v-else>-</div>
                </td>

                <td class="text-right">
                  <div v-if="salesRegisterData.ref_id">
                    {{ salesRegisterData.ref_id || "-" }}
                  </div>

                  <div v-else>-</div>
                </td>

                <td class="text-right">
                  <div v-if="salesRegisterData.card_no">
                    {{ salesRegisterData.card_no || "-" }}
                  </div>

                  <div v-else>-</div>
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_mode &&
                    salesRegisterData.fst_quantity > 0
                      ? "-"
                      : ""
                  }}{{ salesRegisterData.fst_quantity }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_mode &&
                    salesRegisterData.fp_total_amount > 0
                      ? "-"
                      : ""
                  }}{{ currFormat3(salesRegisterData.fp_total_amount) || "-" }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_mode &&
                    salesRegisterData.fp_amount > 0
                      ? "-"
                      : ""
                  }}{{ currFormat3(salesRegisterData.fp_amount) || "0.0" }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_mode &&
                    salesRegisterData.fp_amount > 0
                      ? "-"
                      : ""
                  }}{{ currFormat3(salesRegisterData.fp_amount) || "0.0" }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_mode &&
                    salesRegisterData.charge_type_value_after_offer > 0
                      ? "-"
                      : ""
                  }}{{
                    salesRegisterData.charge_type_value_after_offer
                      ? currFormat3(
                          salesRegisterData.charge_type_value_after_offer
                        )
                      : "0.0"
                  }}
                </td>
                <td class="text-right">-</td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_mode &&
                    salesRegisterData.fp_total_amount > 0
                      ? "-"
                      : ""
                  }}{{
                    currFormat3(salesRegisterData.fp_total_amount) || "0.0"
                  }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.fst_payment_mode }}
                </td>
                <td class="text-left">
                  {{
                    salesRegisterData.refund_mode &&
                    salesRegisterData.payment_mode_amount > 0
                      ? "-"
                      : ""
                  }}
                  {{
                    currFormat3(salesRegisterData.payment_mode_amount) || "0.00"
                  }}
                </td>
                <td class="text-left">
                  {{
                    salesRegisterData.refund_mode &&
                    salesRegisterData.wallet_amount > 0
                      ? "-"
                      : ""
                  }}
                  {{ currFormat3(salesRegisterData.wallet_amount) || "0.00" }}
                </td>
                <td class="text-right">-</td>
                <td class="text-right">-</td>
                <td class="text-right">-</td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_mode &&
                    salesRegisterData.fp_total_amount > 0
                      ? "-"
                      : ""
                  }}{{
                    currFormat3(salesRegisterData.fp_total_amount) || "0.0"
                  }}
                </td>
                <td class="text-right">-</td>
                <td class="text-left">
                  {{
                    salesRegisterData.ft_voucher_name ||
                      salesRegisterData.ft_offer_name ||
                      "-"
                  }}
                </td>
                <td class="text-left">
                  {{
                    salesRegisterData.ft_voucher_code ||
                      salesRegisterData.ft_offer_code ||
                      "-"
                  }}
                </td>
                <td class="text-right">
                  {{
                    salesRegisterData.refund_mode &&
                    salesRegisterData.fp_offer_price > 0
                      ? "-"
                      : ""
                  }}{{ currFormat3(salesRegisterData.fp_offer_price) || "-" }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.refund_mode || "-" }}
                </td>
                <td class="text-left">
                  {{
                    salesRegisterData.refund_mode
                      ? salesRegisterData.refund_first_name +
                        salesRegisterData.refund_last_name
                      : "-"
                  }}
                </td>
                <td class="text-left">
                  {{ salesRegisterData.refund_reason || "-" }}
                </td>

                <template v-if="addonsTotalArr.length">
                  <template v-for="item2 in addonsTotalArr">
                    <td
                      class="text-right"
                      v-for="(item1, index2) in 3"
                      :key="index2 + item2.marc_id"
                    >
                      <template>-</template>
                    </td>
                  </template>
                </template>
                <td class="text-left">-</td>
                <td class="text-left">-</td>
                <td class="text-left">
                  <button
                    class="btn-transparent text-blue"
                    @click="printPdf(salesRegisterData)"
                  >
                    <u>View Invoice</u>
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="d-none">
        <div ref="onPrint" v-html="EjsData"></div>
      </div>
      <div class="swc-report" v-if="salesRegisterRecords.length == 0">
        <table class="swc-report-table">
          <thead class="bg-lightgrey font-weight-bold">
            <th>Unit Name</th>
            <th>Business Date</th>
            <th>Transaction Id</th>
            <th>Receipt No</th>
            <!-- <th>Digital OrderId</th> -->
            <th>DB Date</th>
            <th>DB Time</th>
            <th>Invoice No.</th>
            <th>OutLet</th>
            <th>Category/Genre</th>
            <th>Movie/Item</th>
            <th>ShowDate</th>
            <th>ShowTime</th>
            <th>POS ID</th>
            <th>Employee Code</th>
            <th>User Name</th>
            <th>Screen Name</th>
            <th>Seat Name</th>
            <th>Partner ID</th>
            <!-- <th>Sell Type</th> -->
            <th>Terminal ID</th>
            <th>Merchant Track ID</th>
            <th>Refernce ID</th>
            <!-- <th>STAN</th>
            <th>TVR</th> -->
            <th>Card No.</th>
            <th>Approval Code</th>
            <th>Qty</th>
            <th>Unit Price</th>
            <th>Amount Exclude VAT & GCAM</th>
            <th>Base Amount</th>
            <!-- <template v-for="(chargesData, chargesIndex) in chargesArr"> -->
            <th>VAT</th>
            <th>GCAM</th>
            <!-- </template> -->
            <th>Total Amount</th>
            <th>Payment Method</th>
            <th>Amount</th>
            <th>Ewallet</th>
            <th>Booking Fees</th>
            <th>VAT ON Booking Fees</th>
            <th>Total Booking Fees</th>
            <th>Total Invoice Amount</th>
            <th>AddOns</th>
            <th>Voucher/Offer Name</th>
            <th>Voucher/Offer Code</th>
            <th>Discount</th>
            <th>Refund Type</th>
            <th>Refunded By</th>
            <th>Refund Reason</th>
            <th>Swap With Invoice No</th>
            <th>Swap With Transaction ID</th>
            <th>Print</th>
          </thead>

          <tbody>
            <tr>
              <td colspan="49">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-pagination
      v-if="salesRegisterRecords.length > 0"
      v-model="currentPage"
      :total-rows="paginateRows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>
<script>
  import { BASEURL } from "@/config/index";
  import Printd from "printd";
  import MasterService from "@/services/MasterService";
  import NewReportsService from "@/services/NewReportService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import CinemasService from "@/services/CinemasService";
  import xlsx from "json-as-xlsx";
  import VueHtml2pdf from "vue-html2pdf";
  import * as XLSX from "xlsx";
  import { createQueryString } from "@/services/ApiHelper";
  import PosFnbService from "@/services/PosFnbService";
  import { Role, CLIENT_NAME, CLIENT_NAMES_OBJ } from "@/helper/Role";

  import PosService from "@/services/PosService";
  import { ReportSocket, EventBus } from "@/main.js";

  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
    },
    data() {
      return {
        loaderInstance: null,
        disabledDates: {
          from: new Date(),
        },
        paginateRows: 0,
        perPage: 50,
        currentPage: 1,
        rows: 0,
        guestRows: 0,
        selectedvalue: "50",
        viewingnumbers: [
          { name: "50", id: 1 },
          { name: "100", id: 2 },
          { name: "200", id: 3 },
          { name: "300", id: 4 },
        ],
        //Sorting data
        isSort: false,
        isAscending: true,
        orderby: "",
        columnName: "",
        searchValue: "",

        BASEURL,
        isRoleID: false,
        submitted: false,
        search: "",
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        EjsData: "",
        fromDate: new Date(),
        toDate: new Date(),
        salesRegisterRecords: [],
        fnbSalesRecords: [],
        chargesArr: [],
        addonsTotalArr: [],
        tempData: [],
      };
    },
    beforeMount() {
      // connect here
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      this.getCinemaList();
      // if (CinemaObj) {
      //   this.onSelectCinema(CinemaObj);
      // }
    },
    beforeDestroy() {
      if (ReportSocket) {
        console.log({
          beforeDestroy: ReportSocket,
        });

        ReportSocket.off("GET_SALES_REGISTER_CONNECTED_ACK");
      }
    },
    watch: {
      // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
      //   if (CinemaObj) {
      //     this.onSelectCinema(CinemaObj);
      //   }
      // }
    },
    mounted() {
      console.log({
        mounted: ReportSocket,
      });

      setTimeout(() => {
        console.log({
          mounted_setTimeout: ReportSocket,
        });

        if (ReportSocket && ReportSocket.connected) {
          console.log("========================");
        }
      }, 1000);
    },
    methods: {
      async printPdf(salesRegisterData) {
        const loader = this.$loading.show();

        try {
          const isFnb = salesRegisterData.hasOwnProperty("fst_id");
          const isRefund = isFnb
            ? salesRegisterData.hasOwnProperty("refund_mode") &&
              salesRegisterData.refund_mode != ""
            : salesRegisterData.hasOwnProperty("refund_payment_method") &&
              salesRegisterData.refund_payment_method != "";
          const isPlayCinema =
            CLIENT_NAME.PLAYCINEMA === this.CLIENT_SETUP_NAME;
          const isPlatinum = CLIENT_NAME.PLATINUM === this.CLIENT_SETUP_NAME;
          const isQFXCinema = CLIENT_NAME.QFX === this.CLIENT_SETUP_NAME;
          const isReprint = true;
          // console.log(isRefund, "isRefund");
          let apiCall;
          let params;
          // console.log(salesRegisterData, "salesRegisterDatasalesRegisterData");
          // console.log(
          //   salesRegisterData.hasOwnProperty("fst_id"),
          //   "salesRegisterDatasalesRegisterData"
          // );

          // console.log(
          //   salesRegisterData.hasOwnProperty("refund_payment_method") &&
          //     salesRegisterData.refund_payment_method != "",
          //   "salesRegisterData Condtion"
          // );
          if (isReprint && isQFXCinema) {
            if (isFnb) {
              await PosService.CHECK_LIMIT_REPRINT_FNB({
                orderCode: salesRegisterData.order_code,
                ft_id: salesRegisterData.ft_id || null,
              });
            } else {
              await PosService.CHECK_LIMIT_REPRINT({
                sb_id: salesRegisterData.sb_id,
              });
            }
          }
          if (isFnb) {
            if (isPlayCinema || isPlatinum) {
              apiCall = PosService.GetWOWTicketEjs;
              params = [
                0,
                salesRegisterData.cinema_id || this.dropDown.selectedCinemaId,
                salesRegisterData.order_code,
                isReprint,
                isRefund,
              ];
            } else {
              apiCall = isRefund
                ? PosFnbService.GetFnbRefundEjs
                : PosFnbService.GetFnbOrderEjs;
              params = [
                {
                  OrderCode: salesRegisterData.order_code,
                  Type: "Print",
                  UserID: salesRegisterData.user_created_id,
                  isReprint,
                },
              ];
            }
          } else {
            if (isPlayCinema || isPlatinum) {
              apiCall = PosService.GetWOWTicketEjs;
              params = [
                salesRegisterData.sb_id,
                salesRegisterData.cinema_id,
                0,
                isReprint,
                isRefund,
              ];
            } else {
              console.log(isRefund, "Inside Else");
              apiCall = isRefund
                ? PosService.GetRefundTicketEjs
                : PosService.GetTicketEjs;
              params = [
                salesRegisterData.sb_id,
                salesRegisterData.cinema_id,
                isReprint,
              ];
            }
          }

          const response = await (Array.isArray(params)
            ? apiCall(...params)
            : apiCall(params));

          if (response && response.data) {
            this.EjsData = response.data;
            this.$nextTick(() => {
              if (this.$refs.onPrint && this.EjsData != null) {
                const p = new Printd();
                p.print(this.$refs.onPrint, []);
              }
            });
          }
        } catch (error) {
          this._CatchError(error);
        } finally {
          loader.hide();
        }
      },
      onChangeDate(e, type) {
        console.log("onChangeDate", type);
        if (type == "from") {
          this.toDate = new Date(e);
          this.$forceUpdate();
        }
      },
      onSearch() {
        this.currentPage = 1;
        this.getSalesRegisterReport();
      },
      onChangePagination: function(event) {
        if (event === undefined) {
          this.currentPage = 1;
          this.getSalesRegisterReport();
        } else {
          this.currentPage = event;
          this.getSalesRegisterReport();
        }
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.resetList();
        } else {
          this.selectedvalue = event;
          this.perPage = event;
          this.resetList();
        }
      },
      resetList() {
        // let loader = this.$loading.show();
        this.isSort = false;
        this.isAscending = true;
        this.isAscending = true;
        this.orderby = "";
        this.columnName = "";
        this.currentPage = 1;
        this.getSalesRegisterReport();
      },
      AlrajhiMerchantDetail({ Transportal_ID, Key_name }) {
        const data = [
          {
            MerchantID: "",
            Transportal_ID: "",
            accountNumber: "",
          },
        ];
        const newFilter = data.filter((z) => {
          return z.Transportal_ID == Transportal_ID;
        });
        if (newFilter.length > 0) {
          if (!Key_name) {
            return newFilter["MerchantID"];
          } else {
            return newFilter["Key_name"];
          }
        } else {
          return null;
        }
      },
      onSearchFile: function(value) {
        if (this.search && this.search.length > 0) {
          let search_value = String(this.search || "").toLowerCase();
          let check_array = [
            "movie",
            "payment_method",
            "screen_name",
            "unit_name",
            "invoice_no",
            "outlet",
            "sb_id",
            "ft_id",
            "fst_item_name",
            "fc_category",
            "fst_item_name",
            "fst_payment_mode",
            "order_code",
          ];
          this.salesRegisterRecords = this.tempData.filter((x) => {
            let obj = {};
            let check = false;
            check_array.map((y) => {
              if (typeof x[y] == "object" || !x[y]) {
                // console.log(x[y],"x[y]");
                // obj[y] = JSON.stringify(x[y])
                //   .toLowerCase()
                //   .includes(search_value);
                obj[y] = false;
              } else {
                if (x[y] && (y == "sb_id" || y == "ft_id")) {
                  let value = `T` + x[y] + `, R` + x[y] + `, F` + x[y];
                  obj[y] = String(value || "")
                    .toLowerCase()
                    .includes(search_value);
                } else {
                  obj[y] = String(x[y] || "")
                    .toLowerCase()
                    .includes(search_value);
                }
              }

              if (!check && obj[y]) {
                check = true;
              }
            });
            return check;
          });
        } else {
          this.salesRegisterRecords = this.tempData;
        }
      },
      getDataAddons(data, index, m_id) {
        let filterData = data.findIndex((z) => {
          return z.marc_id == m_id;
        });
        let totalValue = "-";
        if (filterData >= 0) {
          if (index == 0) {
            totalValue =
              data[filterData].singlenetCharge * data[filterData].quantity;
          } else if (index == 1) {
            totalValue =
              data[filterData].totalTaxCharge * data[filterData].quantity;
          } else {
            totalValue = data[filterData].final_price;
          }
        }

        return totalValue;
      },
      excelDownload(BASE_URL) {
        this.loaderInstance = null;

        if (ReportSocket && ReportSocket.connected) {
          let user_id = this.secureStore.get("USINFO").user_id;

          let payload = {
            cinema_id: this.dropDown.selectedCinemaId,
            cinema_name: this.dropDown.selectedCinemaName,
            fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
            toDate: moment(this.toDate).format("YYYY-MM-DD"),
            isExcel: "Y",
            user_id,
            type: 1,
          };

          ReportSocket.emit(
            "GET_SALES_REGISTER_CONNECTED_BETA_OPTIMIZED",
            payload
          );
          this.loaderInstance = this.$loading.show();

          let attempt = 0;
          let loading = false;
          let to = setInterval(() => {
            attempt += 1;

            if (!loading) {
              loading = true;

              NewReportsService.PollForSalesRegisterExcel_Optimized(payload)
                .then((resp) => {
                  let { data } = resp;

                  if (data.is_excel_ready) {
                    clearInterval(to);
                    this.loaderInstance.hide();

                    window.open(data.excel_path || "");
                  }
                  if (attempt > 60) {
                    clearInterval(to);
                    this.loaderInstance.hide();
                  }
                })
                .catch((e) => {
                  // clearInterval(to)
                  // this.loaderInstance.hide()
                  // this._CatchError(e)
                  loading = false;
                })
                .finally(() => {
                  loading = false;
                });
            }
          }, 3500);
        } else {
          try {
            if (!this.dropDown.selectedCinemaId) {
              return this.$toasted.show("Select Cinema");
            }
            if (!this.fromDate) {
              return this.$toasted.show("Select From Date");
            }
            if (!this.toDate) {
              return this.$toasted.show("Select To Date");
            }
            if (moment(this.toDate).isBefore(this.fromDate)) {
              return this.$toasted.show(
                " To Date Should be Greater than From Date"
              );
            }
            let user_id = this.secureStore.get("USINFO").user_id;
            let payload = {
              cinema_id: this.dropDown.selectedCinemaId,
              cinema_name: this.dropDown.selectedCinemaName,
              fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
              toDate: moment(this.toDate).format("YYYY-MM-DD"),
              isExcel: "Y",
              user_id,
              type: 1,
            };
            let qs = createQueryString(payload);
            window.open(
              `${this.REPORT_URL}/api/reports/salesRegisterReport_beta_optimized_excel${qs}`
            );
            // ReportsService.GetSalesRegisterReportMultiple(payload)
            //   .then(response => {
            //     let fileName = 'SalesRegisterReport.xlsx'
            //     const { data } = response;
            //     const blob = new Blob([data]);
            //     const link = document.createElement("a");
            //     link.href = URL.createObjectURL(blob);
            //     console.log('link.href', link.href);
            //     link.download = fileName;
            //     link.click();
            //     URL.revokeObjectURL(link.href);
            //   })
            //   .catch((err) => {
            //     console.log('Error:', err);
            //   })
          } catch (err) {
            console.log("Error:", err);
          }
        }
      },
      ExportExcel(type, fn, dl) {
        var elt = this.$refs.exportable_table;
        var wb = XLSX.utils.table_to_book(elt, {
          sheet: "SalesRegisterReport",
        });
        let loader = this.$loading.show();

        Object.keys(wb.Sheets.SalesRegisterReport)
          .filter((_t) => _t.charAt(0) == "C")
          .map((z) => {
            wb.Sheets.SalesRegisterReport[z].t = "s";
          });
        console.log(wb);
        loader.hide();
        return dl
          ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
          : XLSX.writeFile(wb, fn || "SalesRegisterReport." + (type || "xlsx"));
      },
      moment,
      _excelDownload() {
        let temp_data = [];
        this.houseKeepingRecords.map((x, index) => {
          let obj = { ...x, index: index + 1 };
          temp_data.push(obj);
        });
        let data = [
          {
            sheet: "House Keeping Report",
            columns: [
              {
                value: (row) => moment(row.schedule_date).format("YYYY-MM-DD"),
                label: "Date",
              },
              {
                value: "cinema_name",
                label: "Branch",
              },
              {
                value: "index",
                label: "Show No.",
              },
              {
                value: "screen_name",
                label: "Screen Name",
              },
              {
                value: "movie_name",
                label: "Movie Name",
              },
              {
                value: "start_time",
                label: "Start Time",
              },
              {
                value: "end_time",
                label: "End Time",
              },
              {
                value: (row) =>
                  row.screen_total_seats ? row.screen_total_seats : "-",
                label: "Capacity",
              },
              {
                value: (row) =>
                  row.booked_seats && row.screen_total_seats
                    ? +parseFloat(
                        parseFloat(row.booked_seats / row.screen_total_seats) *
                          100
                      ).toFixed(this.MIN_FRACTION_DIGITS)
                    : "-",
                label: "Occupancy",
              },
            ],
            content: temp_data,
          },
        ];
        let settings = {
          fileName: `HouseKeepingReport_${
            this.dropDown.selectedCinemaName
          }_${new Date().getTime()}`,
        };
        xlsx(data, settings);
      },
      getCinemaList: function() {
        MasterService.GetCinemasByRoles()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              let cinemas = [
                {
                  cine_id: "all",
                  cine_name: "All Cinemas",
                },
              ];
              if (data.Records.length == 1) {
                cinemas = [];
              }
              this.dropDown.cinemas = [...cinemas, ...data.Records];
              this.CinemasCopy = [...cinemas, ...data.Records];
              // this.dropDown.cinemas = [...data.Records];
              // this.CinemasCopy = [...data.Records];
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function(event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.$store.dispatch("selectDropdownCinema", event);
      },
      getSalesRegisterReport() {
        this.salesRegisterRecords = [];
        this.fnbSalesRecords = [];
        this.search = "";
        if (!this.dropDown.selectedCinemaId) {
          return this.$toasted.show("Select Cinema");
        }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
        if (!this.toDate) {
          return this.$toasted.show("Select To Date");
        }

        if (moment(this.toDate).isBefore(this.fromDate)) {
          return this.$toasted.show(
            " To Date Should be Greater than From Date"
          );
        }

        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          limit: this.perPage,
          currentPage: this.currentPage,
          searchValue: this.searchValue,
          columnName: this.columnName,
          orderBy: this.orderby,
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
        };
        NewReportsService.GetSalesRegisterBeta_Optimized(payload)
          .then((response) => {
            const { data } = response;
            if (
              data &&
              data.hasOwnProperty("totalCount") &&
              this.currentPage == 1 &&
              data &&
              data.hasOwnProperty("largeCount")
            ) {
              this.rows = data.totalCount;
              this.paginateRows = data.largeCount;
              if (data.totalCount >= 10) {
                this.rows = data.totalCount;
              } else {
                this.rows = data.totalCount;
                this.selectedvalue = data.totalCount;
              }
            }
            if (data.status && data.Records.length > 0) {
              this.salesRegisterRecords = [...data.Records];
              this.tempData = [...data.Records];
              this.addonsTotalArr = [...data.addons_array];

              if (false) {
                this.chargesArr = [...data.chargesRecords];
              }
              this.$toasted.show(data.message);

              // this.fnbSalesRecords = [...data.fnbSalesRecords];
            } else {
              this.$toasted.show(data.message);
            }
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
    },
  };
</script>

<style>
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }

  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }

  .concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
  }

  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }

  .concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }

  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }

  .gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
  }

  .swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid black;
  }

  .swc-report-table td {
    white-space: nowrap;
  }

  .swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid black !important;
  }

  .swc_table_header th {
    border: 1px solid black !important;
  }

  .no_border {
    border: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/salesRegisterReportNewBetaOptimized.vue